import React from "react";
import { useProductSocialProof } from "../../hooks/useProductSocialProof";
import { formatFusedMatchScoreLine } from "../../utils/socialProofUtils";
import MatchFusedScoreLine from "../product/MatchFusedScoreLine";
import styles from "../../styles/pages/profile/MatchesView.module.css";

/**
 * Fused top-match score + social proof for a My Matches session card.
 */
const SessionTopMatchScore = ({ productId, score }) => {
  const { proof, loading } = useProductSocialProof(productId, Boolean(productId));

  if (score == null) return null;

  if (loading && !proof?.hasSocialProof) {
    return (
      <span className={styles.scoreBadge}>
        {formatFusedMatchScoreLine(score, null)}
      </span>
    );
  }

  return (
    <MatchFusedScoreLine
      score={score}
      proof={proof}
      className={styles.fusedScoreLine}
      as="div"
    />
  );
};

export default SessionTopMatchScore;
